export default __webpack_public_path__ + "static/media/sos.f4382bef.png";